import { render, staticRenderFns } from "./purchaseWareRecord.vue?vue&type=template&id=0b167cbe"
import script from "./purchaseWareRecord.vue?vue&type=script&lang=js"
export * from "./purchaseWareRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports